'use client';

import { fetchCustomerAccount } from '@/api/account';
import { User } from '@/api/types/public';
import { useEffect } from 'react';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { readAuthTokenFromCookie } from '@/utils/tools';
import useSyncToken from './useSyncToken';

/**
 * 客户端同步 token、拉取账户（替代 layout 中 getUserState + prepareStoreInitialData 用户字段）
 */
export const useClientDataInit = () => {
  const setUserInfo = useStore((state) => state.setUserInfo);
  const setWishNum = useStore((state) => state.setWishNum);
  const setUserInfoReady = useStore((state) => state.setUserInfoReady);

  useSyncToken();

  useEffect(() => {
    async function fetchUserInfo() {
      if (!readAuthTokenFromCookie()) {
        return setUserInfoReady(true);
      }
      try {
        const res = await fetchCustomerAccount();
        if (!res || res.code !== 200 || !res.data) return setUserInfoReady(true);
        const user = res.data as User;
        setUserInfo(user);
        if (typeof user.wish_num === 'number') {
          setWishNum(user.wish_num);
        }
      } catch (error) {
        logger.error('Failed to fetch customer account on client init:', error);
      } finally {
        setUserInfoReady(true);
      }
    }
    fetchUserInfo();
  }, [setUserInfo, setUserInfoReady, setWishNum]);
};
